import { getUserData } from "@/app/_providers/user";
import { appUrls, buildSignUpRedirectUrl } from "@/constants";

/**
 * Resolves the CTA destination for the current visitor. Logged-in users go straight to the app
 * deep link; anonymous visitors are routed through sign-up with the destination preserved as a
 * `redirect` param. Shared by the Hero Omnibox and the Interactive Image demo.
 */
export function toCtaUrl(destinationUrl: string): string {
  return getUserData() ? destinationUrl : buildSignUpRedirectUrl(destinationUrl);
}

/**
 * Deep link that claims a freshly generated asset into the image-video app (the post-generation
 * "claim your asset" CTA), carrying the model and prompt so the editor opens pre-filled.
 */
export function buildClaimUrl({
  assetId,
  modelId,
  refinedPrompt,
}: {
  assetId: string;
  modelId?: string | null;
  refinedPrompt?: string | null;
}): string {
  const url = new URL(`${appUrls.imageVideo}/history`);
  url.searchParams.set("claim_asset_id", assetId);
  if (modelId) url.searchParams.set("model", modelId);
  if (refinedPrompt) url.searchParams.set("prompt", refinedPrompt);
  return url.toString();
}
